import { createBrowserRouter, Navigate } from "react-router-dom";
import BasicLayout from "@/pages/Layout";
import { isAuthenticated } from "@/utils/auth";
import { loginLoader } from "./Loder";
import { lazy } from "react";

const Login = lazy(() => import("@/pages/Login"));
const Home = lazy(() => import("@/pages/Home"));
const UserInfo = lazy(() => import("@/pages/Audit/UserInfo")); // 用户资料审核
const PhotosAudit = lazy(() => import("@/pages/Audit/Photos")); // 照片审核
const FeedAudit = lazy(() => import("@/pages/Audit/Feed")); // 动态审核
const CommentsAudit = lazy(() => import("@/pages/Audit/Comments")); // 评论审核
const ReportsAudit = lazy(() => import("@/pages/Audit/Reports")); // 举报审核
const MessagesAudit = lazy(() => import("@/pages/Audit/Messages")); // 消息审核
const MediaAudit = lazy(() => import("@/pages/Audit/Media")); // 媒体审核
const UserList = lazy(() => import("@/pages/User/List")); // 用户信息管理
const BanAudit = lazy(() => import("@/pages/Audit/Ban")); // 封禁审核
const AppManagement = lazy(() => import("@/pages/App")); // App管理
const AppUpgrade = lazy(() => import("@/pages/App/Upgrade")); // App升级

const routes = createBrowserRouter([
  {
    path: "/",
    element: isAuthenticated() ? (
      <BasicLayout />
    ) : (
      <Navigate to="/login" replace />
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/home" replace />,
      },
      {
        path: "home",
        element: <Home />,
      },
      {
        path: "audit",
        children: [
          {
            path: "user-info",
            element: <UserInfo />,
          },
          {
            path: "photos",
            element: <PhotosAudit />,
          },
          {
            path: "feed",
            element: <FeedAudit />,
          },
          {
            path: "comments",
            element: <CommentsAudit />,
          },
          {
            path: "reports",
            element: <ReportsAudit />,
          },
          {
            path: "ban",
            element: <BanAudit />,
          },
          {
            path: "messages",
            element: <MessagesAudit />,
          },
          {
            path: "media",
            element: <MediaAudit />,
          },
        ],
      },
      {
        path: "user",

        children: [{ path: "list", element: <UserList /> }],
      },
      {
        path: "app",
        element: <AppManagement />,
        children: [
          {
            path: "upgrade",
            element: <AppUpgrade />,
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: !isAuthenticated() ? <Login /> : <Navigate to="/" replace />,
    action: loginLoader,
  },
]);

export default routes;
